<template>
  <div class="page post-page">

    <grid class="grid-property"/>

    <div :class="['header-search-property', {scrolled: pageScrolled, 'scrolled-up': pageScrolledUp}]">
      <div class="wrap-search-property">
        <div class="left">

          <figure class="property-logo" @click.prevent="scrollToNav">
            <wp-image v-if="settings && settings.logo"
                      :image="settings.logo"/>
          </figure>

          <div class="menu-side">
            <div class="logo only-mobile">
              <router-link to="/">
                <svg-icon v-if="smallLogo" :iconURL="smallLogo" class="svg-logo"/>
              </router-link>
            </div>

            <mobile-menu-button v-if="isMobile"
                                class="menu-mobile-prop"
                                :menu-open="isMobilePropMenuOpen"
                                @toggleMenu="toggleMenu"/>
          </div>

          <ul v-if="dynamicMenu" :class="['menu', {'menu-mobile-open': isMobilePropMenuOpen}]">
            <li v-for="item in dynamicMenu" :key="item.value">
              <a href="" @click.prevent="scrollToElem(item.value)">{{ item.label }}</a>
            </li>
            <li v-if="settings && settings.residents_link">
              <a :href="settings.residents_link" target="_blank" title="Residents">Residents</a>
            </li>
          </ul>

        </div>

        <div class="right" v-if="filters && filters.bedrooms && !razzEmbedShouldOpen">
          <h4>Find your apartment <span v-if="propertyName">in {{ propertyName }}</span></h4>
          <filter-property :filters="filters"
                           :microsite="true"
                           @clicked="didClick"
          />
        </div>
      </div>

    </div>
    <div class="page-container">
      <div class="hero-banner" v-if="pageLoaded && heroBanner && heroBanner.show_section">
        <wp-image :image="heroBanner.background_image"
                  :isBackground="true"
                  classes="background"
        >
          <div class="overlay" :style="{backgroundColor: heroBanner.overlay_color}"></div>
          <div class="wrap-title">
            <fade-animation
                key="key-anim-1"
                :from="{y: 100, opacity: 0}"
                :to="{y: 0, opacity: 1}"
                class="anim-title"
            >
              <h1 class="title">{{ heroBanner.title }}</h1>
            </fade-animation>
          </div>

        </wp-image>
      </div>

      <section class="text-image section-block" v-if="pageLoaded && textImage && textImage.show_section">

        <fade-animation v-if="textImage.content" class="copy-side" key="key-anim-2">
          <content-module v-bind="textImage.content"/>
        </fade-animation>


        <div class="images-side">
          <div class="wrap-images">
            <fade-animation class="img-container big"
                            v-if="textImage.image"
                            :key="textImage.image.ID"
                            :to="{y: 0, opacity: 1, delay: 0.6}"
            >
              <wp-image
                  :image="textImage.image"
              />
            </fade-animation>
          </div>
        </div>
      </section>

      <section class="gallery section-block" v-if="pageLoaded && gallery && gallery.show_section">
        <heading-block class="property-heading-block" v-bind="gallery.header_content"/>

        <gallery-module :gallery="gallery.gallery" :buttons_color="gallery.buttons_color"/>


      </section>

      <section class="virtual-tours gallery section-block"
               v-if="pageLoaded && virtualTours && virtualTours.show_section">
        <heading-block class="property-heading-block" v-bind="virtualTours.header_content"/>

        <virtual-tour-module :virtual-tours="virtualTours.virtual_tours" :buttons_color="virtualTours.buttons_color"/>


      </section>


      <section class="floor-plans fp2" v-if="pageLoaded && floorPlans && floorPlans.show_section">
        <heading-block class="property-heading-block" v-bind="floorPlans.header_content"/>

        <div class="zeki-container" v-if="buildingURL">
          <razz-embed
              ref="razzEmbed"
              :url="buildingURL"
              @connected="onEmbedConnected"
              class="razz-embed"
          />
        </div>

        <div class="iframe-container" v-if="pageLoaded && floorPlans && floorPlans.show_engrain_iframe && floorPlans.engrain_iframe">
          <iframe :src="floorPlans.engrain_iframe"></iframe>
        </div>


      </section>

      <section class="cort-section section-block" v-if="pageLoaded && cort && cort.link">
        <div class="wrap-cort">
          <div class="logo">
            <wp-image v-if="cort.logo" :image="cort.logo"/>
            <img v-else src="/wp-content/themes/santamonica/static/assets/cort_logo.svg" alt="CORT Logo">
          </div>
          <div class="wrap-content">
            <p>{{ cort.text }}</p>
            <a :href="cort.link" target="_blank">View More</a>
          </div>
        </div>
      </section>

      <section class="amenities section-block" v-if="pageLoaded && amenities && amenities.show_section">
        <heading-block class="property-heading-block" v-bind="amenities.header_content"/>
        <fade-animation class="full-width" key="key-anim-3">
          <div class="wrap-tab full-width">
                        <span v-if="!amenitiesTab"
                              @click="toggleAmenities"
                              class="link-cta large">
                            {{ communityButtonTitle }} <arrow/>
                        </span>
            <span v-if="amenitiesTab"
                  @click="toggleAmenities"
                  class="link-cta">
                            {{ amenitiesButtonTitle }} <arrow/>
                        </span>
          </div>

          <transition-group
              @enter="enter"
              @leave="leave"
          >

            <section key="amenities-tab" v-if="!amenitiesTab && amenities.content" class="section-block amenities-tab">
              <div class="images-side">
                <div class="wrap-images" v-if="amenities.images && !isMobile">

                  <div class="big img-container">
                    <wp-image :key="amenities.images[0].ID"
                              :image="amenities.images[0]"
                    />
                  </div>

                  <div class="small img-container">
                    <wp-image v-if="amenities.images[1]"
                              :key="amenities.images[1].ID"
                              :image="amenities.images[1]"
                    />
                  </div>


                </div>

                <div class="full-width" v-if="amenities.images">
                  <swiper :options="swiperOption" ref="swiperAmenities" class="carousel-wrapper"
                          :class="{'active': isMobile}">
                    <swiper-slide class="img-container-swiper"
                                  v-for="(image, index) in amenities.images"
                                  :key="image.ID"
                    >
                      <wp-image
                          :image="image"
                          ref="sliderAmenities"
                          side-sd="swiper-thumbnail-sd"
                          size-hd="swiper-thumbnail-hd"

                      />

                    </swiper-slide>
                  </swiper>
                </div>


              </div>
              <div v-if="amenities.content" class="copy-side">
                <content-module v-bind="amenities.content"/>
              </div>
            </section>

            <section key="communties-tab" v-if="amenitiesTab && amenities.content_c.title"
                     class="section-block amenities-tab">
              <div class="images-side">
                <div class="wrap-images" v-if="amenities.images_c && !isMobile">

                  <div class="big img-container">
                    <wp-image :key="amenities.images_c[0].ID"
                              :image="amenities.images_c[0]"
                    />
                  </div>

                  <div class="small img-container">

                    <wp-image v-if="amenities.images_c[1]"
                              :key="amenities.images_c[1].ID"
                              :image="amenities.images_c[1]"
                    />
                  </div>


                </div>


                <div class="full-width" v-if="amenities.images_c">
                  <swiper :options="swiperOption" ref="swiperAmenities" class="carousel-wrapper"
                          :class="{'active': isMobile}">
                    <swiper-slide class="img-container-swiper"
                                  v-for="(image, index) in amenities.images_c"
                                  :key="image.ID"
                    >
                      <wp-image
                          :image="image"
                          ref="sliderAmenities"
                          side-sd="swiper-thumbnail-sd"
                          size-hd="swiper-thumbnail-hd"

                      />

                    </swiper-slide>
                  </swiper>
                </div>


              </div>
              <div v-if="amenities.content_c" class="copy-side">
                <content-module v-bind="amenities.content_c"/>
              </div>
            </section>

          </transition-group>
        </fade-animation>

      </section>

      <section class="neighborhood section-block" v-if="pageLoaded && neighborhood && neighborhood.show_section">
        <heading-block class="property-heading-block" v-bind="neighborhood.header_content"/>

        <fade-animation v-if="neighborhood.shortcode" class="full-width" key="key-anim-4">
          <div class="ngbh" v-html="neighborhood.shortcode"></div>
        </fade-animation>

      </section>

    </div>
  </div>
</template>

<script>
import PageMixin from './page.mixin';
import ContentModule from '../modules/ContentModule';
import FadeAnimation from "../modules/includes/FadeAnimation";
import HeadingBlock from '../modules/components/HeadingBlock';
import _filter from 'lodash/filter';
import _cloneDeep from 'lodash/cloneDeep';
import {EventBus} from "../utils/EventBus";
import {RazzEmbed} from '@razz-interactive/vue-components';
import '@razz-interactive/vue-components/dist/razz.css';
import FilterProperty from '../modules/components/FilterProperty'
import GalleryModule from '../modules/GalleryModule'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import MobileMenuButton from '../modules/header/MobileMenuButton'
import svgIcon from "../modules/includes/SVGIcon";
import Arrow from '../modules/svgs/Arrow';
import VirtualTourModule from "../modules/VirtualTourModule";

export default {
  name: "Property",
  mixins: [PageMixin],
  components: {
    ContentModule,
    FadeAnimation,
    HeadingBlock,
    FilterProperty,
    GalleryModule,
    VirtualTourModule,
    MobileMenuButton,
    swiper,
    swiperSlide,
    svgIcon,
    Arrow,
    RazzEmbed,
  },
  data() {
    return {
      razzEmbedShouldOpen: window.razzEmbedShouldOpen,
      availableBeds: null,
      amenitiesTab: true,
      filter: false,
      isMobilePropMenuOpen: false,
      sectionIndex: 0,
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        speed: 1000,
        loop: false,
        breakpoints: {
          640: {
            slidesPerView: 'auto',
            centeredSlides: false,
            spaceBetween: 20
          }
        }
      },
    }
  },
  beforeDestroy() {
    EventBus.bgFooter = false;
    EventBus.bgScrollUpIcon = false;
  },
  computed: {
    wpSettings() {
      return wp.settings || false;
    },
    settings() {
      return this.modules && this.modules.settings;
    },
    propertyName() {
      return this.pageContent && this.pageContent.title.rendered;
    },
    smallLogo() {
      return this.wpSettings && this.wpSettings.small_logo || false;
    },
    filters() {
      //Don't mutate filterOptions
      const filterOptions = this.wpSettings && this.wpSettings.filter_options;

      //This could be used to remove beds that aren't being sent from the embed, but the filter component
      //using it loads the prop on mounted so it isn't reactive when we modify it after it knows.
      // if(this.availableBeds) {
      //     filterOptions.bedrooms = filterOptions.bedrooms.filter(filter => this.availableBeds.includes(filter.value));
      // }

      return filterOptions;
    },
    dynamicMenu() {
      const blocks = [
        {
          label: 'Gallery',
          value: 'gallery',
          active: this.gallery && this.gallery.show_section || false,
        },
        {
          label: 'Virtual Tours',
          value: 'virtual-tours',
          active: this.virtualTours && this.virtualTours.show_section || false,
        },
        {
          label: 'Floor Plans',
          value: 'floor-plans',
          active: this.floorPlans && this.floorPlans.show_section || false,
        },
        {
          label: 'Amenities',
          value: 'amenities',
          active: this.amenities && this.amenities.show_section || false,
        },
        {
          label: 'Neighborhood',
          value: 'neighborhood',
          active: this.neighborhood && this.neighborhood.show_section || false,
        },
      ];

      return _filter(blocks, b => b.active);
    },
    heroBanner() {
      return this.modules && this.modules.banner;
    },
    textImage() {
      const textImage = this.modules && this.modules.text_image && _cloneDeep(this.modules.text_image);
      if (!textImage) return null;

      if (textImage.content) {
        textImage.content["content_background_color"] = this.defineColor(textImage.background_color);
        textImage.content["white_text"] = textImage.white_text;
      }

      return textImage;
    },
    gallery() {
      const gallery = this.modules && this.modules.gallery && _cloneDeep(this.modules.gallery);
      if (!gallery) return null;

      if (gallery.header_content) {
        gallery.header_content["background_color"] = this.defineColor(gallery.background_color);
        gallery.header_content["white_text"] = gallery.white_text;
      }

      gallery["buttons_color"] = this.defineColor(gallery.buttons_color);

      return gallery;
    },
    virtualTours() {
      const vrs = this.modules && this.modules.virtual_tours && _cloneDeep(this.modules.virtual_tours);
      if (!vrs) return null;

      if (vrs.header_content) {
        vrs.header_content["background_color"] = this.defineColor(vrs.background_color);
        vrs.header_content["white_text"] = vrs.white_text;
      }

      vrs["buttons_color"] = this.defineColor(vrs.buttons_color);

      return vrs;
    },
    floorPlans() {
      const floor_plan = this.modules && this.modules.floor_plan && _cloneDeep(this.modules.floor_plan);


      if (!floor_plan) return null;

      if (floor_plan.header_content) {
        floor_plan.header_content["background_color"] = this.defineColor(floor_plan.background_color);
        floor_plan.header_content["white_text"] = floor_plan.white_text;
        floor_plan.header_content["text"] = "Coming Soon"; //TODO Static text until we fix the IFPB issue
      }

      return floor_plan;
    },
    themeSettings() {
      return wp.settings;
    },
    buildingURL() {
      if (this.floorPlans.individual_zeki_app && this.floorPlans.embed_url) {
        return this.floorPlans.embed_url;
      } else {
        return this.themeSettings && this.themeSettings.base_embed_url;
      }

      // const building_id = this.floorPlans.building_id;
      // console.log('building_id', building_id);
      // const baseURL = this.themeSettings && this.themeSettings.base_embed_url;
      //
      // return `${baseURL}?buildings=${building_id || 'AM'}`;
    },
    cort() {
      return this.modules && this.modules.cort && _cloneDeep(this.modules.cort);
    },
    amenities() {
      const amenitiesCloned = this.modules && this.modules.amenities && _cloneDeep(this.modules.amenities);
      if (!amenitiesCloned) return null;

      if (amenitiesCloned.header_content) {
        amenitiesCloned.header_content["background_color"] = this.defineColor(amenitiesCloned.background_color);
        amenitiesCloned.header_content["white_text"] = amenitiesCloned.white_text;
      }

      amenitiesCloned["content"] = {
        body: amenitiesCloned.copy.content.body,
        title: amenitiesCloned.copy.content.title,
        button_list: amenitiesCloned.copy.content.button_list,
        content_background_color: this.defineColor(amenitiesCloned.copy.background_color),
        white_text: amenitiesCloned.copy.white_text,
      };

      amenitiesCloned["content_c"] = {
        body: amenitiesCloned.copy.content_c.body,
        title: amenitiesCloned.copy.content_c.title,
        button_list: amenitiesCloned.copy.content_c.button_list,
        content_background_color: this.defineColor(amenitiesCloned.copy.background_color_c),
        white_text: amenitiesCloned.copy.white_text_c,
      };

      amenitiesCloned["images"] = amenitiesCloned.copy.images;
      amenitiesCloned["images_c"] = amenitiesCloned.copy.images_c;

      return amenitiesCloned;
    },
    neighborhood() {
      const neighborhoodCloned = this.modules && this.modules.neighborhood && _cloneDeep(this.modules.neighborhood);
      if (!neighborhoodCloned) return null;

      if (neighborhoodCloned.header_content) {
        neighborhoodCloned.header_content["background_color"] = this.defineColor(neighborhoodCloned.background_color);
        neighborhoodCloned.header_content["white_text"] = neighborhoodCloned.white_text;
      }
      return neighborhoodCloned;
    },
    pageScrolled() {
      return EventBus.position > 5;
    },
    pageScrolledUp() {
      return EventBus.pageScrolledUp;
    },
    position() {
      return EventBus.position;
    },
    amenitiesButtonTitle() {
      return this.amenities && this.amenities.copy.amenities_button_title || 'Amenities'
    },
    communityButtonTitle() {
      return this.amenities && this.amenities.copy.community_button_title || 'Community Features'
    },
  },
  watch: {
    settings: {
      deep: true,
      handler(val) {
        if (val.color_1) {
          EventBus.bgFooter = val.color_1;
        }
        if (val.color_2) {
          EventBus.bgScrollUpIcon = val.color_2;
        }
      }
    }
  },
  methods: {
    toggleAmenities() {
      this.amenitiesTab = !this.amenitiesTab;
    },
    enter() {
      const fromOptions = {y: 20, opacity: 0};
      const toOptions = {y: 0, opacity: 1, delay: 0.5};
      TweenMax.fromTo('.amenities-tab', 0.8, fromOptions, toOptions);
    },
    leave() {
      const fromOptions = {y: 0, opacity: 1};
      const toOptions = {y: 20, opacity: 0, delay: 0.5};
      TweenMax.fromTo('.amenities-tab', 0.8, fromOptions, toOptions);
    },
    defineColor($colorString) {
      return $colorString === 'color_1' ? this.settings.color_1 : this.settings.color_2;
    },
    scrollToElem(elem) {


      if (this.isMobile) {

        this.$scrollTo(`.${elem}`);

        this.toggleMenu();

      } else {

        let newIndex = 0;

        switch (elem) {
          case 'floor-plans':
            newIndex = 1;
            break;
          case 'amenities':
            newIndex = 2;
            break;
          case 'neighborhood':
            newIndex = 3;
            break;
          case 'virtual-tours':
            newIndex = 4;
            break;
          default:
            newIndex = 0;
        }

        let options = {
          offset: newIndex >= this.sectionIndex ? 185 : 0,
        };

        this.sectionIndex = newIndex;

        this.$scrollTo(`.${elem}`, 500, options);
      }
    },
    scrollToNav() {
      this.$scrollTo(`html,body`, 500);
    },
    checkScroll(elem) {

    },
    onEmbedConnected(frame) {
      if (this.floorPlans.individual_zeki_app && this.floorPlans.embed_url) {
        return;
      }

      const building_id = this.floorPlans.building_id;
      const building_name = this.floorPlans.building_name;

      frame.on(['route', 'buildings-index', 'before'], e => {
        e.preventDefault();
        frame.emit(['router', 'push'], {path: `/buildings/${building_id}`});
      });

      if (window.razzEmbedShouldOpen) {
        frame.on(['platform', 'mounted'], () => {
          frame.emit(['platform', 'embedOptions'], {iframe: true, displayClose: 'left'});
        });

        frame.on(['platform', 'embedOptions'], this.onFrameChangeOptions.bind(this));
      }

      const self = this;
      frame.on(['content', '*'], function (e) {
        const contentType = this.event[1];

        switch (contentType) {
          case 'buildings':
            return _filter(e.data, {id: building_id});
          case 'floors':
            return _filter(e.data, {building_id});
          case 'models':
            const models = _filter(e.data, model => model.label.startsWith(building_name));

            //This is used to calculate available bedroom counts, not currently used
            // const beds = new Set();
            // models.forEach(model => beds.add(`beds-${model.beds}`));
            // self.availableBeds = Array.from(beds);

            return models;
          case 'units':
            return _filter(e.data, {building_id});
        }
      });

      frame.once(['header', 'mounted'], e => {
        frame.emit(['header']);
      });
    },
    onFrameChangeOptions({frame}) {
      if (frame) return;

      //Close tab
      this.$refs.razzEmbed.primaryComponent.destroy();
    },
    didClick(bed) {
      this.$nextTick(() => {
        const embed = this.$refs.razzEmbed;
        if (embed) {
          embed.frame.emit(['header', 'filter-tags'], [bed]);
        }
      });

      const options = {
        offset: 185,
      };
      this.$scrollTo('.floor-plans', 500, options);
    },
    toggleMenu() {
      this.isMobilePropMenuOpen = !this.isMobilePropMenuOpen;
    },
  },
}
</script>

<style lang="scss" scoped>

section {
  /deep/ .heading-block {
    @include box-shadow;
  }
}

.link-cta {
  @include link-cta;

  &.large {
    min-width: 250px;
  }
}

.carousel-wrapper {
  opacity: 0;
  pointer-events: none;
  position: absolute;

  &.active {
    opacity: 1;
    pointer-events: all;
    position: inherit;
  }
}

.swiper-slide {
  width: calc(100vw - 100px);
  max-width: 350px;

  /deep/ img {
    max-width: 100%;
    height: auto;
  }
}

.grid-property {
  /deep/ .big-circle {
    stroke: lighten($color2, 10%);

    .circle {
      fill: $color2;
    }
  }
}

.zeki-container {
  position: relative;
  width: 100%;
  height: calc(100vh - 190px);
}

.page-container {
  margin-top: 257px;
  position: relative;
  z-index: 1;

  @media (max-width: 767px) {
    margin-top: 0;
  }
}

.property-heading-block {
  padding-top: 0 !important;

  /deep/ .full-width {
    max-width: 100%;
  }
}

.header-search-property {
  background-color: #F9F9F9;
  box-shadow: 0 47px 39px -22px rgba(#000, .15) px;
  margin: 0 auto;
  transition: all .3s ease-in-out;
  position: fixed;
  left: 0;
  right: 0;
  min-height: 191px;
  top: 66px;
  @include max-width();
  z-index: 10;


  &.scrolled {
    top: 0;
    min-height: 66px;
    height: 66px;

    .wrap-search-property {
      min-height: 66px;

      .left {
        .property-logo {
          height: 40px;
          overflow: hidden;
          margin-top: 10px;

          @media (max-width: 767px) {
            margin-top: 0;
            margin-right: 5px;
          }

          /deep/ img {
            margin-top: -68px;
          }

          @media (max-width: 767px) {
            /deep/ img {
              margin-top: -68px;
            }
          }
        }

        .menu {
          margin-top: 0;

          @media (max-width: 767px) {
            height: 100vh;
          }
        }
      }

      .right {
        h4 {
          margin-top: -56px;
          opacity: 0;
        }
      }
    }

    &.scrolled-up {
      opacity: 1;
      pointer-events: all;
      margin-top: 0;
      min-height: 191px;
      height: 191px;
      top: 66px;

      @media (max-width: 767px) {
        min-height: 66px;
        height: 66px;
        top: 0;
      }

      .wrap-search-property {
        min-height: 191px;

        @media (max-width: 767px) {
          min-height: 66px;
        }

        .left {
          .property-logo {
            width: 165px;
            margin: 40px 0 0;
            height: auto;
            overflow: visible;

            @media (max-width: 1100px) {
              margin-right: 20px;
            }

            @media (max-width: 767px) {
              height: 40px;
              overflow: hidden;
              margin-top: 0;
              margin-right: 5px;
            }

            /deep/ img {
              margin-top: 0;

              @media (max-width: 767px) {
                // margin-top: -88px;
                margin-top: -68px;
              }
            }
          }

          .menu {
            margin-top: 30px;

            @media (max-width: 767px) {
              margin-top: 0;
            }
          }
        }

        .right {
          h4 {
            margin-top: 56px;
            opacity: 1;
          }
        }
      }

    }
  }

  .wrap-search-property {
    display: flex;
    justify-content: space-between;
    min-height: 191px;
    @include box-shadow();
    transition: all .3s ease-in-out;

    .left {
      width: 1000px;
      margin-left: 57px;
      padding: 0;
      display: flex;

      @media (max-width: 1200px) {
        margin-left: 15px;
      }


      @media (max-width: 1100px) {
        flex-direction: row-reverse;
        margin: auto;
        justify-content: space-between;
      }

      .property-logo {
        cursor: pointer;
        width: 165px;
        margin: 40px 0 0;
        transition: all .3s ease-in-out;

        @media (max-width: 1100px) {
          margin-right: 20px;
        }

        @media (max-width: 767px) {
          margin-top: 0;
        }

        /deep/ img {
          width: 100%;
          height: auto;
          transition: all .3s ease-in-out;
        }
      }

      .menu {
        padding: 0;
        margin: 30px 0 0 10px;
        list-style: none;

        @media (max-width: 767px) {
          display: flex;
          flex-direction: column;
          pointer-events: none;
          position: fixed;
          margin: 0;
          background-color: $color2;
          width: 100vw;
          left: 0;
          top: 0;
          height: 100vh;
          transition: all .3s ease-in-out;
          padding: 60px 20px;
          opacity: 0;
          z-index: 10;
          align-items: center;
          justify-content: center;

          &.menu-mobile-open {
            opacity: 1;
            pointer-events: all;
          }
        }

        li {
          display: inline-block;
          padding: 15px;

          @media (max-width: 1175px) {
            padding: 15px 8px;
          }

          @media (max-width: 767px) {
            width: 215px;
            text-align: left;
          }

          a {
            color: $color1;
            text-decoration: none;
            font-size: 17px;
            transition: all .3s ease-in-out;
            font-weight: normal;

            &:hover {
              color: $color2;
            }

            @media (max-width: 815px) {
              font-size: 15px;
            }

            @media (max-width: 767px) {
              color: #fff;
              font-size: 28px;

              &:hover {
                color: $color1;
              }
            }
          }
        }
      }


    }

    .right {
      margin-right: 50px;
      //display: none; /*TODO Hidden until we fix the IFPB issue*/

      @media (max-width: 1200px) {
        margin-right: 15px;
      }

      @media (max-width: 1100px) {
        display: none;
      }

      h4 {
        margin: 50px 0 10px 20px;
        text-transform: uppercase;
        letter-spacing: 4px;
        transition: all .3s ease-in-out;

        span {
          display: block;
        }
      }
    }
  }

  @media (max-width: 767px) {
    min-height: 66px;
    height: 66px;
    top: 0;

    .wrap-search-property {
      min-height: 66px;

      .left {
        .property-logo {
          height: 40px;
          overflow: hidden;
          margin-top: 0;
          margin-right: 5px;
          position: relative;
          z-index: 11;

          /deep/ img {
            // margin-top: -88px;
            margin-top: -68px;
          }
        }

        .menu {
          margin-top: 0;
        }
      }

      .right {
        h4 {
          margin-top: -26px;
          opacity: 0;
        }
      }
    }
  }
}


.hero-banner {
  height: 500px;
  width: 100%;
  position: relative;
  max-width: calc(100% - 40px);
  margin: auto;
  @include box-shadow;

  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
  }

  .wrap-title {
    position: absolute;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 2;
    width: 100%;
    max-width: 500px;
    left: 50%;
    text-align: center;
  }

  .title {
    text-transform: uppercase;
    color: #fff;
    text-align: center;
  }

  .background {
    background: no-repeat center center transparent;
    background-size: cover;
    width: 100%;
    height: 100%;
  }

  @media (max-width: 1100px) {
    margin-top: 150px;
    height: 400px;
  }

  @media (max-width: 767px) {
    margin-top: 66px;
  }

  @media (max-width: 600px) {
    max-width: calc(100% - 30px);
  }
}

.text-image {
  display: flex;
  align-items: flex-start;
  margin: 80px auto 120px;
  max-width: calc(100% - 40px);

  @media (max-width: 1100px) {
    margin-top: 50px;
    flex-direction: column;
  }

  @media (max-width: 600px) {
    max-width: calc(100% - 30px);
  }

  .images-side {
    width: calc(50% - 30px);
    margin-top: 80px;

    @media (max-width: 1100px) {
      width: 100%;
    }

    .wrap-images {
      display: flex;
      flex-direction: column;
    }

    div.img-container {
      @include box-shadow;

      &.big {
        max-width: 580px;
        width: 100%;
        margin-left: 10px;

        @media (max-width: 1100px) {
          align-self: center;
          margin-left: 0;
          width: 700px;
          max-width: 100%;
        }
      }

      /deep/ img {
        width: 100%;
        height: auto !important;
      }
    }
  }

  .copy-side {
    width: calc(50% + 30px);
    overflow: visible;

    @media (max-width: 1100px) {
      width: auto;
      padding: 0;
      margin-right: auto;
      margin-left: auto;
      max-width: 100%;
    }

    /deep/ .content-container {
      padding: 80px 100px;
      max-width: 642px;
      width: 100%;
      margin-right: 20px;
      float: right;
      @include box-shadow;

      @media (max-width: 1100px) {
        width: 700px;
        max-width: 100%;
        padding: 70px;
        margin: 0;
      }

      @media (max-width: 992px) {
        padding: 40px;
      }

      .copy {
        margin-top: 30px;
        padding-right: 50px;

        @media (max-width: 1100px) {
          padding-right: 0;
        }
      }

      .buttons {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 30px;

        .button:first-child {
          margin-right: 10px;
        }
      }
    }


  }
}

.gallery, .floor-plans, .amenities, .neighborhood {
  max-width: calc(100% - 40px);
  margin: 0 auto 100px;

  @media (max-width: 600px) {
    max-width: calc(100% - 30px);
  }
}

.floor-plans {
  .heading-block {
    margin-bottom: 50px;
  }

  .iframe-container{
    margin-top: 30px;
    height: calc(100vh - 190px);

    iframe {
      width: 100%;
      height: 100%;
      border: 0;
    }
  }
}

.neighborhood {
  .fade-element {
    @include box-shadow;
    margin-top: 50px;
  }
}

.amenities {

  .amenities-tab {
    padding-bottom: 50px;
  }

  .wrap-tab {
    margin-top: 120px;
    margin-left: 130px;

    @media (max-width: 1100px) {
      display: flex;
      justify-content: center;
      margin-left: 0;
    }
  }

  .section-block {
    display: flex;
    align-items: flex-start;
    margin-top: 30px;

    @media (max-width: 1100px) {
      flex-direction: column;
      align-items: center;
      margin-top: 30px;
    }

    @media (max-width: 992px) {
      margin-top: 40px;
    }

    .images-side {
      width: 50%;

      @media (max-width: 1100px) {
        margin-top: 50px;
        width: 100%;
      }

      @media (max-width: 640px) {
        width: calc(100% - 40px);
        margin-left: 40px;
      }

      .wrap-images {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }

      div.img-container {
        @include box-shadow;

        // IE fix
        overflow: hidden;

        &.big {
          max-width: 550px;
          width: 100%;
          margin-right: 20px;


        }

        &.small {
          max-width: 393px;
          width: 100%;
          margin-right: 20px;
          margin-top: 40px;
        }

        /deep/ img {
          width: 100%;
          height: auto !important;
        }
      }
    }

    .copy-side {
      width: 50%;
      margin-top: -30px;
      overflow: visible;

      @media (max-width: 1100px) {
        margin-top: 0;
        width: auto;
        order: -1;
      }

      @media (max-width: 767px) {
        margin: auto;
      }

      /deep/ .content-container {
        max-width: 600px;
        width: 100%;
        margin-left: 20px;
        padding: 70px 90px;
        @include box-shadow();

        @media (max-width: 1100px) {
          margin-left: 0;
          width: auto;
          max-width: 600px;
        }

        @media (max-width: 767px) {
          padding: 40px 50px;
        }

        .copy {
          margin-top: 30px;

          ul {
            padding-left: 20px;

            li {
              margin-bottom: 40px;

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }

        .buttons {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin-top: 30px;

          .button:first-child {
            margin-right: 10px;
          }
        }
      }
    }
  }

}

.menu-mobile-prop {
  width: 44px;
  height: 44px;
  background-color: $color2;
  margin-left: 5px;
  display: none;

  @media (max-width: 767px) {
    display: block;
  }

  /deep/ {
    span {
      background-color: #fff;
    }
  }
}

.menu-side {
  display: flex;
  align-items: center;
  margin-left: 10px;
  position: relative;
  z-index: 11;

  .logo {
    margin-left: 5px;

    .svg-logo {
      font-size: 0;

      /deep/ {
        svg polygon {
          transition: all .3s ease-in-out;
        }
      }
    }

    &.menu-open {
      .svg-logo {

        /deep/ {
          svg polygon {
            fill: $color1;
          }
        }
      }
    }
  }
}

.only-mobile {
  display: none;

  @media (max-width: 767px) {
    display: inline-block;
  }
}

.cort-section {
  max-width: calc(100% - 40px);
  margin: 0 auto 100px;
  background: url(/wp-content/themes/santamonica/static/assets/cort-bg.png) center center no-repeat transparent;
  background-size: cover;

  .wrap-cort {
    display: flex;
    padding: 0 50px;

    @media (max-width: 550px) {
      flex-direction: column;
      align-items: center;
      padding: 0 30px;
    }

    .logo {
      width: 140px;
      max-width: 100%;
      height: auto;
      padding-bottom: 5px;
    }

    .wrap-content {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 30px;

      @media (max-width: 550px) {
        padding: 30px 0;
      }

      p {
        color: #fff;
        text-align: center;
      }

      a {
        color: #fff;
        padding: 10px 30px;
        text-decoration: none;
        background-color: #db2f3d;
        line-height: 1;
        margin: 16px 0 0;
        font-size: 15px;
      }
    }
  }

}

</style>
